<template>
    <v-dialog
        v-model="dialogVisible"
        fullscreen
        hide-overlay
        :retain-focus="false"
        persistent
        transition="dialog-bottom-transition">
        <template v-slot:activator="{ on, attrs }">
          <button
              class="btnDetails"
              v-bind="attrs"
              v-on="on"
              @click="dialogVisible = true"
              style="background-color: transparent;"
            ><slot></slot>              
          </button>
        </template>
        <v-card>
          <v-toolbar
              dark
              color="secondary">
              <v-btn icon dark class="btn btn-primary" @click="closeDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            <v-toolbar-title>{{ $t('usersAdmin.label.detailUser.title') }}</v-toolbar-title>

                <template v-slot:extension>
                  <v-tabs v-model="tab" align-with-title>
                    <v-tabs-slider color="accent"></v-tabs-slider>

                    <v-tab v-for="item in items" :key="item">
                      {{ item }}
                    </v-tab>
                  </v-tabs>
                </template> 

            </v-toolbar>

            <v-tabs-items v-model="tab" class="container mt-5">
              
              <v-tab-item>
                <div class="container mt-4">
                  <detailsUsersAdmin
                  :usersAdmin="usersAdminProps"
                  :disableUserT= "disableUser"
                  />
                </div>
              </v-tab-item>

          </v-tabs-items>
  
        </v-card>
    </v-dialog>
  
</template>
  
<script>

  import detailsUsersAdmin from '@/views/users_admin/pages/detail_users_admin/components/form_users_admin_component.vue';
  import  EventBus  from '@/utils/event_bus.js';

  export default {
    
    name:"detailsUserAdmin",
    components: {
      detailsUsersAdmin,
    },
    props: {
      usersAdminProps: {
        required: true
      },
      disableUser:{
        required: true
      }
    },

    data () {
      return {
        dialogVisible: false,
        tab: null,
        items: [
          this.$t('label.tab')
        ],
      }  
    },

    async mounted() {
      if( !this.usersAdminProps){
        this.usersAdminProps = "";
      }
      EventBus.$on('reload-update-usersAdmin', (name) => {
        this.usersAdminProps.nombre = name;
        this.closeDialog()  
      });
    },

    methods: {
      closeDialog() {
        this.dialogVisible = false;        
        window.location.reload();
      },

    }
  };
</script>
  
<style lang="css" scoped>


  .btnDetails .v-icon {
    color: #6E17A5;
    margin-bottom: 12px;
  }
  
</style>
  